import _ from 'lodash';
import { ReduxAction } from '../actions';
import { WindowSizeState } from './state';

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function WindowSize(
  state: WindowSizeState = {},
  action: ReduxAction
): WindowSizeState {
  switch (action.type) {
    case 'UPDATE_WINDOW_SIZE': {
      return _.cloneDeep(action.size);
    }
    default: {
      return state;
    }
  }
}
